import Select from '@/common/components/Select'
import { useProducts } from '@/common/hooks/queries/useProducts'
import useDebounce from '@/common/hooks/useDebounce'
import { Mapper } from '@/common/services/mapper'
import { ProductData } from '@/common/types/product.type'
import { ProductCategoryData } from '@/common/types/productCategory.type'
import { options as priceRuleOptions } from '@/features/publicCompanyLeadsFunnel/constants/priceRuleOptions.constant'
import { UseFieldArrayAppend } from 'react-hook-form'
import { PublicCompanyLeadsFunnelContractProductCategoryValidationSchema } from '../schemas/update.schema'

interface ContractProductCategoryAppendProductProps {
  productCategoryId?: string
  contractProducts: PublicCompanyLeadsFunnelContractProductCategoryValidationSchema['contract_product_category_products']
  appendContractProduct: UseFieldArrayAppend<PublicCompanyLeadsFunnelContractProductCategoryValidationSchema>
}

export const ContractProductCategoryAppendProduct = ({
  productCategoryId,
  contractProducts,
  appendContractProduct,
}: ContractProductCategoryAppendProductProps) => {
  const [searchProduct, setSearchProduct] = useDebounce('')

  const { data: productOptions } = useProducts({
    filters: { search: searchProduct, category: productCategoryId },
    mapper: Mapper.mapToOptionsWithItem<ProductCategoryData>({ labelFieldName: 'display_name', valueFieldName: 'id' }),
  })

  return (
    <Select
      name="search_contract_products"
      placeholder="Pesquisar Produtos"
      value={null}
      onInputChange={setSearchProduct}
      onChange={(newValue) => {
        appendContractProduct({
          product: (newValue as { item: ProductData }).item,
          global_value_in_currency: '',
          global_value_in_unit_for_consumption: '',
          price_rule: priceRuleOptions.find(({ value }) => value === 'dynamic'),
        })
      }}
      options={
        productOptions?.filter(
          (option) => !contractProducts?.some((contractProduct) => contractProduct?.product?.id === option.value),
        ) || []
      }
    />
  )
}
